import { Button } from '@/components/ui/button';

interface OverlayProps {
  searchInput: string;
  handleClearInput: () => void;
}

export default function NoRowOverlay({
  searchInput,
  handleClearInput,
}: OverlayProps) {
  return (
    <div className="flex size-full items-center justify-center">
      {searchInput ? `No results matching "${searchInput}"` : 'No stores'}
      {searchInput && (
        <Button onClick={handleClearInput} variant="link">
          Clear Search
        </Button>
      )}
    </div>
  );
}
